<!--
  The view selector and this view's filters share one row, wrapping onto
  further rows only when the window is too narrow to fit them side by side.
  Rendered outside the guards below so the selector is still available when
  the list itself cannot load.
-->
<div class="d-flex flex-wrap align-items-center mt-3 mb-3"
     style="gap: 8px 24px;">
  <app-reservations-view-toggle *ngIf="customerId"
                                [customerId]="customerId"></app-reservations-view-toggle>
  <!--
    The checkboxes are one flex item, not two, so that when the row is too
    narrow to hold them side by side the second wraps underneath the FIRST
    rather than back to the far left under the selector.
  -->
  <div class="d-flex flex-wrap" style="gap: 4px 24px; flex: 1 1 0; min-width: 240px;"
       *ngIf="!customerNotFound && (serverError === null)">
    <div class="form-check mb-0">
      <input class="form-check-input" type="checkbox"
             [(ngModel)]="showPastReservations"
             (ngModelChange)="onFiltersChange()"
             name="showPastReservations"
             id="showPastReservationsCustomer">
      <label class="form-check-label" for="showPastReservationsCustomer">
        Show past reservations
      </label>
    </div>
    <div class="form-check mb-0">
      <input class="form-check-input" type="checkbox"
             [(ngModel)]="showNonpaymentCancelledReservations"
             (ngModelChange)="onFiltersChange()"
             name="showNonpaymentCancelledReservations"
             id="showNonpaymentCancelledReservationsCustomer">
      <label class="form-check-label"
             for="showNonpaymentCancelledReservationsCustomer">
        Show reservations which were cancelled due to non-payment
      </label>
    </div>
  </div>
</div>

<div *ngIf="customerNotFound">
  <h2>Customer not found.</h2>
</div>

<div *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div *ngIf="!customerNotFound && (serverError === null)">
  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; height: 39px;">
          <span style="position: relative; top: -2px;">
            {{ showPastReservations ? 'Event Reservations' : 'Upcoming Event Reservations' }}
          </span>
        </th>
      </tr>
      <tr>
        <th scope="col">Date</th>
        <th scope="col">Time</th>
        <th scope="col">Event</th>
        <th scope="col">Payment</th>
        <th scope="col">Fee Type</th>
        <th scope="col">Add-ons</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingReservations && reservationPartsList">
      <tr *ngFor="let reservationPart of reservationPartsList.results"
          [class.reservation-cancelled]="reservationPart.is_cancelled">
        <td>{{ dateStringFromISO8601(reservationPart.start_local_date) }}</td>
        <td>
          <span class="text-nowrap">{{ timeStringFromISO8601TimeOnly(reservationPart.start_local_time) }}</span>
          -
          <span class="text-nowrap">{{ timeStringFromISO8601TimeOnly(reservationPart.end_local_time) }}</span>
        </td>
        <td>
          <a [routerLink]="getResEventDetailsLink(reservationPart)">
            {{ reservationPart.event_type_name }}
          </a>
        </td>
        <td>
          <span *ngIf="(reservationPart.invoice_id !== null) && ((reservationPart.fee_name) || (reservationPart.add_on_names.length > 0))">
            <app-payment-status-badge [status]="reservationPart.payment_status"
                                      [invoiceId]="reservationPart.invoice_id"></app-payment-status-badge>
          </span>
          <span *ngIf="(reservationPart.invoice_id === null) || !((reservationPart.fee_name) || (reservationPart.add_on_names.length > 0))" class="text-muted">N/A</span>
        </td>
        <td>
          <span *ngIf="reservationPart.fee_name">
            {{ capitalizeFirstLetter(reservationPart.fee_name) }}
          </span>
          <span *ngIf="!reservationPart.fee_name" class="text-muted">N/A</span>
        </td>
        <td style="white-space: nowrap">
          <span *ngIf="reservationPart.add_on_names.length > 0">
            <ng-container *ngFor="let add_on_name of (reservationPart.add_on_names_display || reservationPart.add_on_names)">
              {{ add_on_name }}<br>
            </ng-container>
          </span>
          <span *ngIf="reservationPart.add_on_names.length === 0" class="text-muted">None</span>
        </td>
        <td class="table-button-cell">
          <button class="btn btn-sm btn-secondary table-12px-button float-right"
                  type="button"
                  (click)="openReservationDetailsModal(reservationPart)">
            View
          </button>
        </td>
      </tr>
      <tr *ngIf="reservationPartsList.results.length === 0">
        <td colspan="99" class="text-muted">
          {{ showPastReservations ? 'No reservations' : 'No upcoming reservations' }}
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingReservations || !reservationPartsList">
      <tr>
        <td colspan="99" class="text-muted">Loading reservations...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <app-pagination-row [(pageSize)]="pageSizeCustomerUpcomingReservations"
                      [(pageNum)]="pageNumber"
                      [reloadSubject]="filtersChangedSubject"
                      [lastPageNum]="lastPageNumber()"></app-pagination-row>
</div>
